export default "__VITE_ASSET__C738X5QS__"